import { cn } from "@/utils/tailwind";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-background/30 vtac:bg-accent/30 animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
